import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import style from "config/style";
import { useCallback } from "react";

// "#C0392B", // INJURED GROUP COLOR IS EXCLUDED
const [, ...otherColors] = style.colors.options;

interface OhCustomColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

const ColorPickerWrapper = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  rowGap: 8,
});

const ColorOption = styled("div")<{ selected: boolean; color: string }>(({ selected, color }) => ({
  display: "inline-block",
  position: "relative",
  width: 26,
  height: 26,
  borderRadius: 30,
  cursor: "pointer",
  marginRight: 16,
  backgroundColor: color,
  outlineOffset: 2,
  "&::after": selected
    ? {
        content: '""',
        display: "block",
        border: "1px solid #afafaf",
        position: "absolute",
        left: -3,
        top: -3,
        width: 32,
        height: 32,
        borderRadius: 50,
      }
    : {},
}));

function CustomColorPicker(props: OhCustomColorPickerProps) {
  const { onChange, value } = props;
  const { t } = useTranslation();

  const handleOnKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>, color: string) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onChange(color);
      }
    },
    [onChange]
  );

  return (
    <ColorPickerWrapper role="listbox" aria-label={t("global.color_picker_label")}>
      {otherColors.map((color) => (
        <ColorOption
          role="option"
          aria-label={color}
          key={color}
          color={color}
          aria-selected={value === color}
          selected={value === color}
          tabIndex={0}
          onClick={() => onChange(color)}
          onKeyDown={(event) => handleOnKeyDown(event, color)}
        />
      ))}
    </ColorPickerWrapper>
  );
}

export default CustomColorPicker;
